import styled from "styled-components";
import { Video } from "../Video";

export const ButtonWrapper = styled.div`
  width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  @media screen and (max-width: 400px) {
    width: 100%;
  }
`;

export const HomepageComponentWrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

export const HomepageComponentFirstImage = styled.img`
  max-height: 80px;
`;

export const HomepageComponentTitle = styled.h1`
  font-size: 24px;
  text-align: center;
  width: 95%;
  max-width: 500px;
`;

export const HomepageComponentVideo = styled(Video)`
  margin-bottom: 40px;
  width: 95%;
  max-width: 1000px;
`;

export const HomepageComponentImage = styled.img`
  margin-bottom: 40px;
  width: 95%;
  max-width: 1000px;
`;
